import { render, staticRenderFns } from "./ListBuyBox.vue?vue&type=template&id=0b5fef37&scoped=true"
import script from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListBuyBox.vue?vue&type=style&index=0&id=0b5fef37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5fef37",
  null
  
)

export default component.exports